import { useState } from "react";
import { useParams } from "react-router-dom";
import { useData } from "../contexts/DataContext";
import ListView from "../components/views/ListView";
import TaskDialog from "../components/TaskDialog";
import { FilterBar, useTaskFilters } from "./ProjectView";
import { Plus } from "lucide-react";

export default function SpaceView() {
  const { spaceId } = useParams();
  const { tasks, projects, spaces, users, setOpenTaskId } = useData();
  const [dialog, setDialog] = useState(null);
  const space = spaces.find((s) => s.id === spaceId);
  const spaceProjects = projects.filter((p) => p.space_id === spaceId);
  const projectIds = new Set(spaceProjects.map((p) => p.id));
  const filters = useTaskFilters(tasks.filter((t) => projectIds.has(t.project_id)));

  if (!space) return <div className="p-6 text-sm text-muted-foreground" data-testid="space-not-found">Space not found.</div>;

  const topLevel = filters.filtered.filter((t) => !t.parent_id);
  const groups = spaceProjects.map((p) => ({
    key: p.id, label: p.name, color: space.color, projectId: p.id,
    tasks: topLevel.filter((t) => t.project_id === p.id),
  }));

  return (
    <div className="p-4 md:p-6" data-testid="space-view">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <div className="flex items-center gap-2">
          <span className="h-3.5 w-3.5 rounded-sm" style={{ backgroundColor: space.color }} />
          <h2 className="font-heading text-xl font-bold tracking-tight">{space.name}</h2>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <FilterBar filters={filters} users={users} />
          <button data-testid="add-task-button" onClick={() => spaceProjects[0] && setDialog({ group: { projectId: spaceProjects[0].id, status: "todo" } })}
            className="h-8 px-3 flex items-center gap-1.5 text-sm font-medium rounded-md bg-[#E31E24] hover:bg-[#C81A1F] text-white transition-colors">
            <Plus size={15} />Add Task
          </button>
        </div>
      </div>

      {groups.length === 0 && <p className="text-sm text-muted-foreground py-10 text-center">No projects in this space yet. Add one from the sidebar.</p>}

      <ListView groups={groups} users={users}
        onOpenTask={(t) => setOpenTaskId(t.id)}
        onEditTask={(t) => setDialog({ task: t })}
        onAddTask={(g) => setDialog({ group: g })}
        onAddSubtask={(t) => setDialog({ parentId: t.id, group: { projectId: t.project_id } })} />

      {dialog && (
        <TaskDialog open onClose={() => setDialog(null)}
          projectId={dialog.task?.project_id || dialog.group?.projectId}
          parentId={dialog.parentId || null}
          task={dialog.task || null}
          defaultStatus={dialog.group?.status || "todo"} />
      )}
    </div>
  );
}
